import React from 'react';

import {
    IonSkeletonText
} from '@ionic/react';
import { Row, Col } from 'reactstrap';

class GeneralSkeletonText extends React.Component {

    render() {
        return (
            <Row className="mx-2">
                <Col xs="12 p-1">
                    <IonSkeletonText animated className="w-100" style={{ height: '80vh', borderRadius: '5px' }}></IonSkeletonText>
                </Col>
            </Row >
        )
    }
}

export default GeneralSkeletonText;